import { CLEAR_SIGNUP_FORM, UPDATE_SIGNUP_FORM } from '../actions/reduxAction';

const INITIAL_STATE = {
  name: '',
  email: '',
  password: '',
  passwordVerify: '',
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_SIGNUP_FORM:
      return {
        ...state,
        ...action.payload,
      }
    case CLEAR_SIGNUP_FORM:
      return INITIAL_STATE;
    default:
      return state;
  }
}
